import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select, Spin } from 'antd';
import { DocumentCard, PhoneInput } from 'cmt-ui-kit';
import moment from 'moment';

const { Option } = Select;

const RequiredLabel = ({ children }) => (
  <span>
    <span className="required-asterisk">*</span>
    {children}
  </span>
);

const disabledDate = (current) => {
  const overAge = moment().subtract(8, 'years');
  return current && overAge < current;
};

const PersonalDataBlock = ({
  t,
  form,
  searchPatient,
  genders,
  setDocumentType,
  handleOnBlur,
}) => {
  return (
    <Row gutter={10} className='mb-30'>
      <Col lg={5} xs={24}>
        <Form.Item label={<RequiredLabel>{t('reservations.patientForm.documentTypeAndNumber')}</RequiredLabel>} className="mb-0 custom-document-label">
          <Spin className='cmt-spin patient-form document-select-wrapper' spinning={searchPatient?.isLoading || false}>
            <DocumentCard
              countryCode="PE"
              setDocumentType={setDocumentType}
              handleOnDocumentNumberBlur={handleOnBlur}
              form={form}
              classNameStyle='input-height'
              type='person'
            />
          </Spin>
        </Form.Item>
      </Col>
      <Col lg={5} xs={24}>
        <Form.Item name="names" label="Nombres" className="mb-0" rules={[{ required: true, message: 'Nombres son requeridos' }]}>
          <Input className="cmt-input custom-document-input" placeholder="Ingrese los nombres" />
        </Form.Item>
      </Col>
      <Col lg={10} xs={24}>
        <Form.Item name="last_name" label="Apellidos" className="mb-0" rules={[{ required: true, message: 'Apellidos son requeridos' }]}>
          <Input className="cmt-input custom-document-input" placeholder="Ingrese los apellidos" />
        </Form.Item>
      </Col>
      <Col lg={4} xs={24}>
        <Form.Item name="gender" label="Género" className="mb-0">
          <Select className="cmt-select custom-document-input" placeholder="Seleccione género" allowClear>
            {genders?.map(gender => (
              <Option key={gender.id} value={gender.id}>
                {gender.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col lg={4} xs={24} className='mt-15'>
        <Form.Item name="birthdate" label="Fecha de Nacimiento" className="mb-0">
          <DatePicker className="cmt-date-picker custom-document-input w-100" placeholder="DD/MM/YYYY" format="DD/MM/YYYY" allowClear disabledDate={disabledDate} />
        </Form.Item>
      </Col>
      <Col lg={3} xs={24} className='mt-15'>
        <Form.Item shouldUpdate={(prevValues, currentValues) => prevValues.birthdate !== currentValues.birthdate} label="Edad" className="mb-0">
          {({ getFieldValue }) => {
            const bd = getFieldValue('birthdate');
            return <Input value={bd ? `${moment().diff(moment(bd), 'years')} años` : ''} className="cmt-input custom-document-input text-center" disabled />
          }}
        </Form.Item>
      </Col>
      <Col lg={6} xs={24} className='mt-15'>
        <Form.Item name="email" label="Correo electrónico" className="mb-0" rules={[{ type: 'email', message: 'El email es inválido' }]} size="small">
          <Input className="cmt-input" type="email" placeholder='Ingrese email' />
        </Form.Item>
      </Col>
      <Col lg={6} xs={24} className='mt-15 phoneCol'>
        <PhoneInput.ReactPhone countryCode="PE" form={form} labelText={t('reservations.patientForm.phoneLabel')} optional={true} />
      </Col>
      <Col lg={5} xs={24} className='mt-15'>
        <Form.Item name="external_id" label="ID Externo" className="mb-0">
          <Input className="cmt-input custom-document-input" placeholder="Ingrese ID externo" />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default PersonalDataBlock;
